module.exports = __webpack_public_path__ + "static/edinme-mail-a8db8509b1e12f9999699d8d99025e26.png";